export default __webpack_public_path__ + "static/media/back-arrow.d6e40d3d.svg";